import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { Link } from "@tanstack/react-router";
import useUserStore from "@/store/userStore";

type NavLinksProps = {
  sections: { id: string; labelKey: string }[];
  activeSection: string;
  scrollToSection: (sectionId: string) => void;
  isChallenge: boolean;
  isCircle: boolean;
};

const NavLinks: FC<NavLinksProps> = ({
  sections,
  activeSection,
  scrollToSection,
  isChallenge,
  isCircle = false,
}) => {
  const { t } = useTranslation();
  const { token } = useUserStore();

  return (
    <div className="mx-1 flex gap-1 overflow-x-auto md:mx-4 md:gap-4 [&>a:not([data-main])]:pe-2 [&>a]:my-auto">
      {isChallenge && !!token && (
        <Button
          variant="ghost"
          asChild
          className="bg-[--neutrals-gray-03] font-[650] hover:bg-[--neutrals-gray-03]"
          size="lg"
          data-main
        >
          <Link
            aria-label="Go to create challenge page"
            to="/donor-profile"
            search={{ page: "challenges" }}
          >
            <div>{t("challenge.backToChallenges")}</div>
          </Link>
        </Button>
      )}

      {isCircle && (
        <Button
          asChild
          variant="ghost"
          className="bg-[--neutrals-gray-03] font-[650] hover:bg-[--neutrals-gray-03]"
          size="lg"
          data-main
        >
          <Link
            aria-label="Go to create circle page"
            to="/donor-profile"
            search={{ page: "circles" }}
          >
            <div>{t("circlePage.backToCircles")}</div>
          </Link>
        </Button>
      )}

      {sections.map(({ id, labelKey }) => (
        <a
          key={id}
          href={`#${id}`}
          className={activeSection === id ? "font-[650]" : "font-[350]"}
          onClick={(e) => {
            e.preventDefault();
            scrollToSection(id);
          }}
        >
          {t(labelKey)}
        </a>
      ))}
    </div>
  );
};

export default NavLinks;
